import { fieldsConfig } from './configFields';

const orderSummaryOptions = [
  {
    property: 'nametag',
    label: 'Name for roster'
  },
  {
    property: 'email',
    label: 'Email'
  },
  {
    property: 'phone',
    label: 'Phone'
  },
  {
    property: 'address',
    label: 'Address'
  },
  // {
  //   property: 'age',
  //   label: 'Age',
  //   mapping: fieldsConfig['age'].options
  // },
  {
    property: 'share',
    label: 'Include on roster',
    defaultValue: 'do not share',
    mapping: [
      { label: 'name', value: 'name' },
      { label: 'pronouns', value: 'pronouns' },
      { label: 'email', value: 'email' },
      { label: 'phone', value: 'phone' },
      { label: 'city and state', value: 'address' },
    ]
  },
  // {
  //   property: 'dietaryPreferences',
  //   label: 'Dietary Preferences',
  //   mapping: fieldsConfig['dietaryPreferences'].options
  // },
  // {
  //   property: 'dietaryRestrictions',
  //   label: 'Dietary Restrictions',
  //   mapping: fieldsConfig['dietaryRestrictions'].options
  // },
  // {
  //   property: 'allergies',
  //   label: 'Allergies'
  // },
  {
    property: 'carpool',
    label: 'Transportation',
    mapping: fieldsConfig['carpool'].options
  },
  {
    property: 'bedding',
    label: 'Bedding',
    mapping: fieldsConfig['bedding'].options
  },
  {
    property: 'volunteer',
    label: 'Volunteering',
    mapping: fieldsConfig['volunteer'].options
  },
  // {
  //   property: 'housing',
  //   label: 'Housing'
  // },
  {
    property: 'housing',
    label: 'Camp room considerations',
    mapping: fieldsConfig['housing'].options
  },
  {
    property: 'roommate',
    label: 'Roommate'
  },
  {
    property: 'misc',
    label: 'Do any of these apply?',
    mapping: [
      { label: "Minor", value: 'minor' },
      { label: "No photos", value: 'no-photos' },
      { label: "I am interested in a beginner's lesson", value: 'beginner' },
    ]
  },
  {
    property: 'comments',
    label: 'Comments'
  }
];

export default { orderSummaryOptions };